import { render } from "./deleteFriendly.vue?vue&type=template&id=2b007b38"
import script from "./deleteFriendly.vue?vue&type=script&lang=js"
export * from "./deleteFriendly.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__